import { USD_PER_AI_CREDIT } from "./aiCredits.js";
import { USD_PER_VOICE_CREDIT } from "./voiceCredits.js";
const SELF_SERVE_CREDIT_PACK_OFFERS = {
  ai_credits: {
    unitPriceUsd: USD_PER_AI_CREDIT,
    quantities: [1e4, 25e3, 5e4]
  },
  voice_credits: {
    unitPriceUsd: USD_PER_VOICE_CREDIT,
    quantities: [500, 1e3, 2e3]
  }
};
export {
  SELF_SERVE_CREDIT_PACK_OFFERS
};
//# sourceMappingURL=creditPacks.js.map
